<template>
    <b-modal size="md" :id="id" centered>
        <div class="mb-3 text-center">
            {{ $t('mr_setting.note_4') }}
        </div>
        <div class="text-danger font-weight-bold mb-3 text-center">
            {{ $t('mr_setting.warning_1') }}
        </div>
        <div class="mb-3 text-center">
            {{ $t('mr_setting.proceed_msg') }}
        </div>
        <template #modal-footer>
            <div class="d-flex justify-content-center w-100">
                <button class="btn btn-success btn-w-md mx-1" @click="$bvModal.hide(id)">
                    {{ No }}
                </button>
                <button class="btn btn-confirm-custom btn-w-md mx-1" @click="confirm()">
                    {{ Yes }}
                </button>
            </div>

        </template>
    </b-modal>
</template>

<script>
export default {
    props: {
        id: { type: String, default: 'modal-mr-confirmation' },
    },
    computed: {
        Yes() {
            return this.$t('mr_setting.yes')
        },
        No() {
            return this.$t('mr_setting.no')
        }
    },
    methods: {
        confirm() {
            this.$bvModal.hide(this.id);
            this.$emit('click-handler', true);
        },
    },
}
</script>

<style scoped>
.btn-confirm-custom {
    /* background-color: #f5f7fa; */
    color: #000;
    border: 1px solid #777 !important;
}

.btn-confirm-custom:hover {
    background-color: rgb(68, 106, 218);
    color: #fff;
    border: 2px solid #000;
}
</style>